module.exports = __webpack_public_path__ + "img/Wallet-empty.c31584d1.png";